import React from "react";

import CustomTooltip from "../../../../../../components/CustomTooltip/CustomToolTip.component";
import useDecimalFormat from "../../../../../../hooks/useDecimalFormat";
import * as Styles from "./styles";

interface CellProps {
  nomeEmpresa: string;
  espontaneo: number;
  retorno: number;
  indicacao: number;
  ligacao: number;
  total: number;
}

interface Props {
  data: CellProps;
}

const TableItem: React.FC<Props> = ({ data }) => {
  return (
    <Styles.Container>
      <Styles.Cell style={{ minWidth: 110 }}>
        <CustomTooltip
          title={<p>{data?.nomeEmpresa ? data?.nomeEmpresa : "--"}</p>}
        >
          <Styles.CellText>{data.nomeEmpresa}</Styles.CellText>
        </CustomTooltip>
      </Styles.Cell>
      <Styles.Cell style={{ minWidth: 60 }}>
        <Styles.CellText style={{ marginLeft: 18 }}>
          {/* @ts-ignore */}
          {useDecimalFormat(data.espontaneo)}
        </Styles.CellText>
      </Styles.Cell>
      <Styles.Cell style={{ minWidth: 40 }}>
        <Styles.CellText style={{ marginLeft: 10 }}>
          {/* @ts-ignore */}
          {useDecimalFormat(data.retorno)}
        </Styles.CellText>
      </Styles.Cell>
      <Styles.Cell>
        <Styles.CellText style={{ marginLeft: 12 }}>
          {/* @ts-ignore */}
          {useDecimalFormat(data.indicacao)}
        </Styles.CellText>
      </Styles.Cell>
      <Styles.Cell>
        <Styles.CellText style={{ marginLeft: 11 }}>
          {/* @ts-ignore */}
          {useDecimalFormat(data.ligacao)}
        </Styles.CellText>
      </Styles.Cell>
      <Styles.Cell>
        <Styles.CellText style={{ color: "#2D5BFF", marginLeft: 6 }}>
          {/* @ts-ignore */}
          {useDecimalFormat(data.total)}
        </Styles.CellText>
      </Styles.Cell>
    </Styles.Container>
  );
};

export default TableItem;
